import jsPDF from 'jspdf';

export const GeneratePdffromHtml = (templateHtml, base64CB, borderData) => {
  const doc = new jsPDF();
  const createTempdiv = document.createElement('div');
  createTempdiv.innerHTML = templateHtml;
  createTempdiv.classList.add('ck-content');
  createTempdiv.classList.add('preview-data');

  let base64 = { val: '' };
  doc.html(createTempdiv, {
    callback: function (generatedPdf) {
      const checkBorder = borderData;

      ///adding border for each page
      if (checkBorder) {
        const parseBorder = borderData;
        if (parseBorder) {
          //for adding border to each page
          for (let i = 0; i < doc.getNumberOfPages(); i++) {
            doc.setPage(i + 1);
            doc.setDrawColor(0, 0, 0);
            doc.setLineWidth(4);

            if (parseBorder > 4) {
              doc.setLineWidth(2);
            } else {
              doc.setLineWidth(parseBorder);
            }
            doc.rect(5, 5, doc.internal.pageSize.width - 10, doc.internal.pageSize.height - 10, 'S');
          }
        }
      }

      const pdfbase64 = generatedPdf.output('datauristring');
      base64.val = pdfbase64;
      base64CB(base64.val);
      return base64;
    },
    margin: [0, 0, 0, 0],

    x: 0,
    y: 0,
    width: 190,
    windowWidth: 675
  });
  return base64.val;
};
